import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import QueryString from 'query-string';
import { Api } from '@shell/shell-ui';
import { toast } from 'react-toastify';

// The CIPM 4 "Sign out" / "Sign out of all devices" actions on the manage-profile form end only the
// Auth0 session(s) and send the browser straight to /login (with or without an Auth0 state),
// bypassing the API, so the GIDS session cookies survive. A full page load of /login while still
// logged in is therefore treated as such a return and finished by the regular GIDS logout, which
// clears them. In-app navigations to /login (location.key !== 'default') keep the old redirect.
const INITIAL_LOCATION_KEY = 'default';

const isIdpSignOutReturn = (location, queryParams) => location.pathname === '/login'
  && location.key === INITIAL_LOCATION_KEY
  && !queryParams.code
  && !queryParams.invitation
  && !queryParams.error
  && !queryParams.referer
  && !queryParams['ext-prompt'];

export default function NoAuthRoute({ component, ...rest }) {
  const location = useLocation();
  const queryParams = QueryString.parse(location.search);
  const user = useSelector((state) => state.user.loggedUser);
  const Component = component;
  const finishIdpSignOut = Boolean(user) && isIdpSignOutReturn(location, queryParams);

  useEffect(() => {
    if (!finishIdpSignOut) {
      return;
    }

    const logout = async () => {
      try {
        const { data } = await Api.get('/logout/service');
        window.location.replace(data);
      } catch (error) {
        toast.error('Unable to retrieve logout url');
      }
    };

    logout();
  }, [finishIdpSignOut]);

  if (finishIdpSignOut) {
    return null;
  }

  if (user && rest.path !== '/reset-password/:token') {
    if (queryParams.referer) {
      window.location = queryParams.referer;
      return null;
    }
    return <Navigate to='/' />;
  }

  return (
    <Component {...rest} />
  );
}
